import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSfpSmartFilterGroupEntity } from './m-sfp-smart-filter-group.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('fk__rbac_role__id', ['fkRbacRoleId'], {})
@Index('fk_m_sfp_smart_filter_group__id', ['fkMSfpSmartFilterGroupId'], {})
@Entity(
	'm_sfp_smart_filter_group__rbac_role',
	{},
	{ label: 'Smart Filter Group RBAC Role' },
)
export class MSfpSmartFilterGroupRbacRoleEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_m_sfp_smart_filter_group__id',
		nullable: true,
		unsigned: true,
	})
	public fkMSfpSmartFilterGroupId!: number | null;

	@Column('int', { name: 'fk__rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;

	@Column('smallint', { name: 'sortOrder', nullable: true })
	public sortOrder!: number | null;

	@ManyToOne(
		() => RbacRoleEntity,
		(rbacRole) => rbacRole.mSfpSmartFilterGroupRbacRoles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;

	@ManyToOne(
		() => MSfpSmartFilterGroupEntity,
		(mSfpSmartFilterGroup) =>
			mSfpSmartFilterGroup.mSfpSmartFilterGroupRbacRoles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: 'fk_m_sfp_smart_filter_group__id', referencedColumnName: 'id' },
	])
	public fkMSfpSmartFilterGroup!: MSfpSmartFilterGroupEntity;
}
